import React, { useContext, useState } from 'react';
import axios from 'axios';
import { Box, Rating, Snackbar, Alert } from '@mui/material';
import Modal from '@mui/material/Modal';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import SubmitClassFeedback from '../../actions/course/SubmitClassFeedback';
import { AuthContext } from '../../context/AuthContext';
import ModalStyle from '../../data/ModalStyle';
import ToastMessage from '../tosts/ToastMessage';

const WeeklyFeedback = ({ course, show, onHandelClose }) => {
  const { user } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    rating: 0,
    message: '',
  });

  const [submitting, setsubmitting] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
const [message, setMessage] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRatingChange = (event, newValue) => {
    setFormData({ ...formData, rating: newValue });
  };

  const SubmitFeedback = async () => {
    setsubmitting(true);
    const res = await SubmitClassFeedback({
      payload: {
        session: user.SessionId,
        review: formData.message,
        rating: formData.rating,
        batch_id: course.batch_id,
        course_url: course.course_url
      }
    });

    if (res) {
      if (res.status === "success") {
        setToastMessage("Feedback submitted successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setsubmitting(false);
        onHandelClose();
      } else {
        setToastMessage("Something went wrong");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setsubmitting(false);
        if (res.message) {
          setMessage(res.message);
        } else {
          setMessage("An error occurred while submitting feedback.");
        }
      }
    } else {
      setToastMessage("Something went wrong");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setsubmitting(false);
    }
  };

  return (
    <>
      <Box sx={ModalStyle} className="col-lg-4 p-3 col-md-5 col-sm-6 col-11 br-5">
        <div>
          <h4 className='text-center'>Weekly Class Feedback</h4>
          <Alert severity="info" sx={{ width: '100%' }}>
          {" Please submit your last week class feedback to access your course dashboard."}
        </Alert>
        </div>
        <hr />
        <p className="mb-3">
          {parseInt(formData.rating) === 1 ? "Poor"
            : parseInt(formData.rating) === 2 ? "Below Average"
            : parseInt(formData.rating) === 3 ? "Average"
            : parseInt(formData.rating) === 4 ? "Good"
            : parseInt(formData.rating) === 5 ? "Excellent"
            : ""}
        </p>
        <form onSubmit={(e) => { e.preventDefault(); SubmitFeedback(); }}>
          <Rating
            size="large"
            name="rating"
            value={formData.rating}
            onChange={handleRatingChange}
          />
          <textarea
            rows="5"
            value={formData.message}
            onChange={handleChange}
            name="message"
            className="mt-3 mb-3 w-100 form-control"
            placeholder="Write your feedback"
          />

          

          <button className="btn mt-4  btn-primary btn-sm w-100" disabled={submitting}>
            {submitting ? "Submitting..." : "Submit Class Feedback"}
          </button>
          {message && <span className="text-danger text-center d-block mt-2">{message}</span>}
        </form>
      </Box>
    
      <ToastMessage open={snackbarOpen} handelClose={()=>setSnackbarOpen(false)} severity={snackbarSeverity} message={toastMessage}/>
    </>
  );
};

export default WeeklyFeedback;